export var sortByQuestion = function (faqItems, locale) {
    var collatorLocale = locale;
    if (collatorLocale === "fr-mea") {
        collatorLocale = "fr-fr";
    }
    else if (collatorLocale === "en-emea" || collatorLocale === "en-mea") {
        collatorLocale = "en-us";
    }
    var collator = Intl.Collator(collatorLocale);
    return faqItems
        .slice()
        .sort(function (x, y) { return collator.compare((x.question || '').toLowerCase(), (y.question || '').toLowerCase()); });
};
